module.exports = __webpack_public_path__ + "img/moon-pay.75b359a.webp";